<ng-container *ngIf="policyDetail">
    <app-policy-header [keys]="detailKeys?.header" [showButtons]="isDetailPage" [isContractorDocumentExpired]="isContractorDocumentExpired" [registryDetailsError]="errorRetrieveingRegistryDetail" (navigationRequested)="onNavigationRequested($event)">
    </app-policy-header>
    <ng-container>
        <div class="mt-4 mb-4">
            <h6 class="card-header-label">Contraente</h6>
            <app-policy-card [item]="subject" [title]="subjectName" [keys]="subjectKeys" [tooltip]="'Contraente'">
            </app-policy-card>
        </div>
    </ng-container>
    <ng-container *ngIf="isDetailPage">
        <h6 class="card-header-label">Dati della polizza</h6>
        <div class="card-disclaimer-label mb-2" *ngIf="!isOFSAuthorized">{{ cannotOperateWarnMessage }}</div>
        <div class="card-disclaimer-label mb-2" *ngIf="isContractorDocumentExpired">{{ contractorDocExpiredWarnMessage }}</div>
        <div class="card-disclaimer-label mb-2" *ngIf="errorRetrieveingRegistryDetail">{{ contractorDocServiceErrorMessage }}</div>
        <div class="card-disclaimer-label mb-2" *ngIf="showPolicyConstraintMessage">{{ policyConstraintMessage }}</div>
        <app-detail-accordion [detail]="policyDetail" [accordions]="detailKeys?.accordions">
        </app-detail-accordion>
    </ng-container>
</ng-container>

<router-outlet></router-outlet>
